
     <script lang="ts">
      import MobileInfo from "./MobileInfo.svelte";
      import MobileHourView from "./MobileHourView.svelte";
     
      </script>
    
        <div class="tab-pane show active" role="tabpanel">

          <MobileInfo></MobileInfo>
          <MobileHourView></MobileHourView>
          <small class="float-right muted">vir: <a class="text-light" target="_blank" href="https://www.gov.si/drzavni-organi/organi-v-sestavi/agencija-za-okolje/">ARSO</a></small> 

        </div>